import { mobileQuery } from "./_mobileQuery";

export const setupFooter = (): void => {
  const footerMask = document.getElementById("footerMask");
  const footerBg = document.getElementById("footerBg");

  if (!footerMask || !footerBg) return;

  ScrollTrigger.create({
    trigger: ".c-footer",
    scrub: true,
    start: "top 75%",
    end: "100% 100% ",
    invalidateOnRefresh: true,
    onEnter() {
      document.documentElement.classList.add("is-footer-appear");
    },
    onLeaveBack() {
      document.documentElement.classList.remove("is-footer-appear");
    },
    onUpdate(st) {
      const w = document.documentElement.offsetWidth;
      const h = window.innerHeight;
      const factor = mobileQuery.matches ? 768 / w : 1;

      // 六角形の内接円がだいたい直径 76 = 半径 38
      // その円が画面を覆う拡大率を求める
      const r = Math.sqrt(w ** 2 + h ** 2);
      const scale = (r / 38) * factor;

      footerBg.style.transform = `scale(${Math.max(
        1,
        scale *
          Quart.easeIn(mobileQuery.matches ? st.progress * 2 : st.progress)
      )})`;
    }
  });
};
